import { gsap } from "gsap";
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrambleTextPlugin);

document.addEventListener("DOMContentLoaded", function () {
  if (!document.querySelector(".l-contact-animation-text")) {
    return;
  }

  const backgroundTextItems = document.querySelectorAll(".text-item");

  if (backgroundTextItems.length === 0) {
    return;
  }

  const initTextItems = () => {
    backgroundTextItems.forEach((item) => {
      item.dataset.originalText = item.textContent;
      item.dataset.text = item.textContent;
      item.style.width = 'auto'; // Reset width before measurement
      const textWidth = item.getBoundingClientRect().width;
      item.style.width = `${textWidth}px`;
      item.style.textAlign = 'center';
    });
  };

  document.fonts.ready.then(() => {
    initTextItems();
  });

  function revealTexts() {
    const revealPromises = Array.from(backgroundTextItems).map((item, index) => {
      return new Promise(resolve => {
        const tl = gsap.timeline({
          delay: index * 0.05,
          onComplete: resolve
        });

        // Set initial state for the curtain (off-screen left)
        // The text is already hidden by CSS (visibility: hidden)
        gsap.set(item, { '--curtain-translate-x': '-101%' });

        tl.to(item, { // 1. Curtain slides in
            '--curtain-translate-x': '0%',
            duration: 0.4,
            ease: 'power3.in'
          })
          .set(item, { // 2. Text becomes visible (under the curtain)
            visibility: 'visible'
          })
          .to(item, { // 3. Curtain slides out
            '--curtain-translate-x': '110%',
            duration: 0.8,
            ease: 'power3.out'
          });
      });
    });

    Promise.all(revealPromises).then(() => {
      setTimeout(scrambleRandomText, 1000);
    });
  }

  function scrambleRandomText() {
    const randomIndex = Math.floor(
      Math.random() * backgroundTextItems.length
    );
    const randomItem = backgroundTextItems[randomIndex];
    const originalText = randomItem.dataset.text;

    gsap.to(randomItem, {
      duration: 1,
      scrambleText: {
        text: originalText,
        chars: "■▪▌▐▬",
        revealDelay: 0.5,
        speed: 0.3,
      },
      ease: "none",
      onUpdate: function() {
        const chars = "■▪▌▐▬";
        const regex = new RegExp(`[${chars}]`, 'g');
        this.targets()[0].innerHTML = this.targets()[0].textContent.replace(regex, (match) => `<span class="scrambling-text">${match}</span>`);
      },
      onComplete: function() {
        this.targets()[0].innerHTML = this.targets()[0].dataset.originalText;
      }
    });

    const delay = 0.5 + Math.random() * 2;
    setTimeout(scrambleRandomText, delay * 1000);
  }

  const animationTrigger = document.querySelector('.l-contact-animation-text');

  if (animationTrigger) {
    ScrollTrigger.create({
      trigger: animationTrigger,
      start: "top 80%", // Trigger when 80% of the element is visible
      once: true, // Only trigger once
      onEnter: () => {
        revealTexts();

        backgroundTextItems.forEach((item, index) => {
          const delay = index * 0.1;
          gsap.to(item, {
            duration: 2 + (index % 3),
            repeat: -1,
            yoyo: true,
            ease: "sine.inOut",
            delay: delay
          });
        });
      },
    });
  }
});
